/**
 * An OpenFOAM run's time limit, `overrides.max_run_time_s` (ENG-2864):
 * seconds on the wire, hours on screen.
 *
 * The bounds mirror `max_run_time_s` on `SimpleAlgorithmOverrides` and
 * `ChtOverrides` in `models/src/khorium_models/sim_params.py`. When a run
 * reaches its limit the solver stops cleanly and the run is stopped, so it
 * can be continued.
 */

export const TIME_LIMIT_DEFAULT_S = 14_400;
export const TIME_LIMIT_MIN_S = 60;
export const TIME_LIMIT_MAX_S = 39_600;

/** Hours to two decimals: 14 400 s reads `4`, 5 400 s reads `1.5`. */
export function secondsToHours(seconds: number): number {
  return Math.round((seconds / 3600) * 100) / 100;
}

export function hoursToSeconds(hours: number): number {
  return Math.round(hours * 3600);
}

/** Whether the backend accepts this limit (1 minute to 11 hours). */
export function timeLimitInRange(seconds: number): boolean {
  return seconds >= TIME_LIMIT_MIN_S && seconds <= TIME_LIMIT_MAX_S;
}
